import { Controller } from "@hotwired/stimulus";
import "flatpickr/dist/flatpickr.min.css";
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

export default class extends Controller {
  connect() {
    flatpickr(".js-date-picker", {
      locale: Japanese,
      allowInput: true,
      disableMobile: true,
      dateFormat: "Y/m/d",
      wrap: true,
      clickOpens: false,
    });
  }
}
